import { checkCookie } from './functions'

(function($) {



var is_mobile = $(window).width() < 768 ? true : false;



function msieversion() {

	var ua = window.navigator.userAgent;

	var msie = ua.indexOf("MSIE ");



	if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)){

		jQuery('body').addClass('explorer');

	}



	return false;

}



jQuery(document).ready(function(){

	msieversion();

});



// menu accessibility

function has_active_elements(container) {

	var active_elements = $(container).has(document.activeElement).length;

	if (active_elements == 0) {

	   return true;

	} else {

		return false;

	}

}




$('.header-menu .mega-wrap ul.submenu').mouseover(function() {

	$(this).parent().parent().addClass('open');

});

$('.mega-parent').mouseleave(function() {

	$(this).parent().parent().removeClass('open');

});

$('.header-menu .mega-wrap ul.submenu').mouseleave(function() {

	$(this).parent().parent().removeClass('open');

});



// mobile menu

$(document).on('click','.mobile .sub-triger', function() {

	var triger = $(this);

	var a_link = $(triger).closest('a');

	var wrap = a_link.parent().parent().hasClass('headlines') ? $(a_link).closest('.links-group') : $(a_link).closest('li');

	wrap.find('.mega-wrap, ul').first().slideToggle('fast'); 

	triger.toggleClass('fa-angle-down');

	triger.toggleClass('fa-angle-up');

});





// 
$('.menu li, #dm-languages-list').each(function() {
	
	var menu_item = $(this);
	var remove_open = function() {
		if ( has_active_elements(menu_item) ) {
		   $(menu_item).removeClass('open');
	    }	
	}
	
	$(menu_item).on('hover, mouseenter, active, focus click','a',function(){
		$(menu_item).addClass('open');
	});

	$(menu_item).mouseleave(remove_open);
	
});











$('.dm-accessibility').each(function() {

	

	var container = $(this);

	if ( !has_active_elements(container) ) {

	   $('body').removeClass('acc-open');

	}

	

	$(container).on('active, focus','a',function(){

		$('body').addClass('acc-open');

	});

	

	$(container).on('click','a#open-accessibility',function(){

		$('body').toggleClass('acc-open');

	});

	

	$(container).focusout( function(){

		if ( !has_active_elements(container) ) {

		   $('body').removeClass('acc-open');

		}

	});

	

});



/**********************/

/* Headline font-size */

/**********************/



$(window).resize( function(){

	resize_headlines();

});



$(document).ready( function(){

	resize_headlines();

	var span_triger_submenu = '<span class="sub-triger fa-angle-down"></span>';

	$('.mobile .header-menu .menu li').has('ul').find('> a').append(span_triger_submenu);

	$('.mobile .header-menu .links-group').has('ul').find('> div > a').append(span_triger_submenu);

	

});



function downsize_font(elem){

	var current_font_size = parseInt($(elem).css('font-size'));

	current_font_size--;

	$(elem).css('font-size',current_font_size + 'px');

}



function resize_headline(headline_wrap){

	

	var headline_wrap_width = headline_wrap.width();

	var headline = headline_wrap.find('h3, h1');

	var headline_width = headline.width()+30;

	var current_font_size = parseInt($(headline).css('font-size'));

	

	var elements_width = 0;

	$(headline_wrap).find('> *:not(h3, h1)').each(function() {

		elements_width += $(this).width();

	});

	var avalable_width = headline_wrap_width - elements_width;

	

	if( avalable_width <= headline_width ){

		var get_precent = avalable_width / headline_width;

		var new_font_size = Math.floor(current_font_size*get_precent)-1;

		new_font_size = new_font_size < 18 ? 18 : new_font_size;

		$(headline).css('font-size',new_font_size + 'px');

	} else {

		return;

	}

	

}



function resize_headlines(){

	$('.dm-widget .headline').each(function() {

		var headline_wrap = $(this);

		resize_headline(headline_wrap);		

	});

}



/****************/

/* sidebar menu */

/****************/

var wp_page_url = window.location.href;

$('.sidebar .menu li').each(function() {	

	var link_li = $(this);

	

	if( $(link_li).find('a').filter("[href='"+wp_page_url+"']").length ){

		$(link_li).addClass('active current');

	}

});



//

/*

$('.skiping a').keypress(function(e) {

	

	var a_link = $(this);

	var container = $(a_link).parent();

	

	if(e.which == 13) { // enter		

		if( (container).has("ul") ){

			$(container).find('li:nth-child(2) a').first().focus();

		} else {

			$(a_link).attr('data-target').focus();

		}

	}

	

	

	

});



// highlight container for skiplink

$(document).on('focus', 'a.dm-skiplink', function(e) {

	

	var skiplink = $(this);

	var target = $(skiplink).attr('data-highlight');

	

	$(target).addClass('highlight');

});



$(document).on('blur', 'a.dm-skiplink', function(e) {

	

	var skiplink = $(this);

	var target = $(skiplink).attr('data-highlight');

	

	$(target).removeClass('highlight');

});



$(document).on('focus','.skiping a', function(e) {

	

	var focus_link = $(this);

	var container = $(focus_link).parent();

	var parent_container = $(container).parent().parent();

	var current_tabindex = $(focus_link).attr('tabindex');

	var highlight_target = $(focus_link).attr('data-highlight');

	var link_target = $(focus_link).attr('data-target');

	var is_top_link = current_tabindex == 1;

	

	$(highlight_target).addClass('highlight');

	

	if( (container).is(":last-child") ){

		$(parent_container).next().find('a').focus();

	} else if( (container).is(":first-child") ){

		$(parent_container).find('> a').focus();

	} else {

		$(link_target).focus();

	}

	

});



$(document).on('blur','.skiping a', function(e) {

	var blur_link = $(this);

	var highlight_target = $(blur_link).attr('data-highlight');

	$(highlight_target).removeClass('highlight');

});

*/



$(document).on('focus','.skiping a.go-to-skiplinks', function(e) {

	$('.skiping > ul > li:nth-child(2) a').focus();

});



$(document).on('focus','.skiping li:last-child a', function(e) {

	$(this).closest('ul').find('li:nth-child(2) a').first().focus();

});



$(document).on('focus','.skiping li:first-child a', function(e) {

	$(this).closest('ul').find('li:nth-last-child(2) a').last().focus();

});





/*********************/

/***** archive *******/

/*********************/

$(document).on('click','.grid-list-switcher a', function() {

	if( !$(this).hasClass('active') ) {

		$('.grid-list-switcher a').toggleClass('active');

		$('.posts').toggleClass('list');

		$('.posts').toggleClass('grid');

	}

});



/*********************/

/***** counter *******/

/*********************/

	

$.fn.isOnScreen = function(){



	var win = $(window);

	

	var viewport = {

		top : win.scrollTop(),

		left : win.scrollLeft()

	};

	viewport.right = viewport.left + win.width();

	viewport.bottom = viewport.top + win.height();

	

	var bounds = this.offset();

	bounds.right = bounds.left + this.outerWidth();

	bounds.bottom = bounds.top + this.outerHeight();

	

	return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

	

};



$(window).scroll(function(){

	$('.counter').each(function(){

		var counter = $(this);

		var counter_loaded = $(counter).hasClass('loaded');

		

		if( $(counter).isOnScreen() && !counter_loaded ){

			$(counter).addClass('loaded');

			var data_from = 1;

			var data_to = 2000;

			$(counter).find('.timer .num').each(function(){

				var timer = $(this);

				data_to = $(timer).attr('data-from');

				data_to = $(timer).attr('data-to');

				$(timer).countTo({

					from: data_from,

					to: data_to,

					speed: 5000,

					refreshInterval: 50,

					onComplete: function(value) {

						//console.debug(this);

					}

				});

			});

		}

	});

});



/********************/

/** letters filter **/

/********************/



var $grid = $('.articles').masonry({

	originLeft: false,

	isStill: true,

	columnWidth: 'div'

});



$(document).on('click','.alphabet a', function(e) {

	

	if( $(this).is('.all') ){

		$('.articles div').show();

	} else {

		var letter = $(this).attr('data-letter');

		$('.articles').find('div[data-letter='+letter+']').show();

		$('.articles').find('div:not([data-letter='+letter+'])').hide();

	}

	

	$grid.masonry('layout');

	

});



/*********/

/** FAQ **/

/*********/



var $faq = $('.qa-list').masonry({

	originLeft: false,

	isStill: true,

	columnWidth: 'div'

});



$(document).on('click','.qa-list > div > div', function(e) {

	

	var qa = $(this);

	$(qa).parent().parent().find('> div > div').not(qa).removeClass('active');

	$(qa).toggleClass('active');

	$faq.masonry('layout');

	

});





$(document).ready( function(){

	$('.mobile .faq-wrap .faq-tabs').each( function(){

		var nav = $(this);

		var count_width = 0;

		nav.find('a').each( function(){

			count_width += $(this).width() + 48;

		});

		nav.width(count_width);

	});

});



$(document).on('click','.faq-tabs a', function(e) {

	

	$('.faq-tabs a').not(this).removeClass('active');

	$(this).addClass('active');

	

	if( $(this).is('.all') ){

		$('.qa-list > div').show();

	} else {

		var filter = $(this).attr('data-filter');

		$('.qa-list').find('> div[data-filter='+filter+']').show();

		$('.qa-list').find('> div:not([data-filter='+filter+'])').hide();

	}

	

	$faq.masonry('layout');

	

});


$('.aac-accordion').beefup({
	openSingle: true,
	accessibility : true,
	
});



/**********************/

/** PDF Files filter **/

/**********************/



var $files_list = $('.files-list').masonry({

	originLeft: false,

	isStill: true,

	columnWidth: 'div'

});



$(document).on('submit','.search-files form', function(e) {

	

	var form_files = $(this);

	var str = $(form_files).find('input[type="text"]').val();

	var cat = $(form_files).find('option:selected').val();

	

	scroll_to_element($('.files-list'));

	

	var container_to_search = cat != '' ? $('.files-list > div[data-cat="'+cat+'"]') : $('.files-list > div');

	

	$('.files-list > div').each( function(){

		$(this).hide();

	});

	

	$(container_to_search).each( function(){

		

		var container = $(this);

		var files = $(container).find('li');

		$(files).show();

		

		var count = 1;

		if(str != ''){

			count = 0;

			$(files).each( function(){

				if( $(this).find('a:contains("'+str+'")').length ){

					count++;

				} else {

					$(this).hide();

				}

			});

		}

		

		

		

		if(count){

			$(container).show();

		}

	});

	

	

	

	/*if(cat != ''){

		$('.files-list > div[data-cat="'+cat+'"]').each( function(){

			$(this).hide();

		});

	} else {

		$('.files-list > div').each( function(){

			

		});

	}*/

	

	$files_list.masonry('layout');	

	e.preventDefault();

	

});



/****************/

/** filter-tax **/

/****************/

$('.filter-tax').each( function(){

	var filter = $(this);

	$(this).on('click','a.btn', function() {

		window.location.href = $(filter).find('select option:selected').val();

	});

});







/***********/

/** popup **/

/***********/

function dm_popup(){

	$('.popup-wrap').fadeIn();

	$('.popup-wrap').addClass('loading');

	

	jQuery.post(

		'/wp-admin/admin-ajax.php', 

		{

			'action': 'city_coockie',

		}, 

		function(response){

			$('.popup-content').html(response);

			$('.popup-wrap').addClass('active');

			$('.popup-wrap').removeClass('loading');

		}

	)

	

}



function ajax_loader(state){

	if(!state){state = false;}

	

	if(state == 'on'){

		$('img.ajax-loader').fadeIn();

	} else {

		$('img.ajax-loader').fadeOut();

	}

}



$(document).on('click','.video-triger', function() {	

	var data_popup = $(this).attr('data-popup');

	$('.popup-wrap').fadeIn();

	$('.popup-wrap').addClass('active');

	$('.popup-wrap .popup-content').html(data_popup);

});



$(document).on('click','.popup-wrap.active', function(e) {

	if( $(e.target).is('.popup-content *:not(.close-popup, .close-popup *)') ){

		e.preventDefault();

		return;

	}

	$(this).fadeOut('fast',function() {

		$(this).removeClass('active');

		$(this).find('.popup-content').html('');

	});

	

});





/* menu btn */

$(document).on('click','a.mobile-menu-btn', function() {	

	$('body').addClass('mobile-menu-active');

	var icon = $(this).find('i');

	icon.removeClass('fa-bars');

	icon.addClass('fa-close');	

});



$(document).on('click','body.mobile-menu-active *', function() {

	var pressed = $(this);

	if( $(pressed).closest(".header-menu").length>0 ){

		

		if( pressed.hasClass('sub-triger') || pressed.hasClass('current-lang') ){

			return false;

		} else {

			//return;

		}

		

	} else {

		$('body').removeClass('mobile-menu-active');

		var icon = $('a.mobile-menu-btn').find('i');

		icon.addClass('fa-bars');

		icon.removeClass('fa-close');

		//return false;

	}

	

});





/* header sticky */

$(window).on('scroll', function(){

	if(is_mobile){

		var top_position = $('body').scrollTop();

		if( top_position >= 110 ){

			$('body').addClass('sticky');

		} else {

			$('body').removeClass('sticky');

		}

	}

});



/* contact */

$(document).on('click','a.contact-btn, a.mobile-contact-btn', function() {	

	var data_popup = $('.contact-popup');

	$(data_popup).fadeIn();

	$(data_popup).addClass('active');

});



$(document).on('click','a.close-contact-popup', function() {	

	var data_popup = $('.contact-popup');

	$(data_popup).fadeOut();

	$(data_popup).removeClass('active');

});





/***********/

/** alert **/

/***********/

function dm_alert(message,dismiss){

	if(!dismiss){

		dismiss = 6000;

	}

	var dm_alert = $('.dm-alert');

	var alert_content = $(dm_alert).find('.alert-content');

	

	$(alert_content).html(message);

	$(dm_alert).addClass('active');

	/*setTimeout(function(){

		$(dm_alert).removeClass('active');

		},

		dismiss

	);*/

	

}



$(document).on('click','.dm-alert', function() {

	$(this).removeClass('active');

	$('.alert-content').html('');

});



/******************/

/** Staff Filter **/

/******************/

function filter_staff_ajax(filter,page){
	ajax_loader('on');
	
	var data = $(filter).serialize();
	jQuery.post(

		'/wp-admin/admin-ajax.php', 
		{
			'action': 'staff_search_results',
			'data' : data,
			'page': page
		}, 

		function(response){
			$('.dm-archive.dm-widget .footer').remove();
			$('.staff-filter-search-results').html(response);

			ajax_loader('off');

		}

	)
}

$(document).on('submit','.staff-filter', function(e) {
	var filter = $(this);
	filter_staff_ajax(filter,1);
	e.preventDefault();
});

function filter_staff_letters(letter){
	var data_letter = letter.data('letter');
	var wrapper = letter.parent();
	wrapper.find('a').not(letter).removeClass('active');
	$('input[name="letter"]').val(data_letter);
	letter.addClass('active');
	$('.staff-filter').trigger('submit');
}

$(document).on('click','.ajax-paging a',function(e){
	
	e.preventDefault();
	var btn = $(this);
	var url = $(btn).attr('href');
	var filter = btn.closest('.content').find('.staff-filter');
	console.log(filter);
	var page = /paged=(\d+)/.exec(url)[1];;
	filter_staff_ajax(filter,page);
	
});

$('.alphabet a').click( function(){
	var letter = $(this);
	filter_staff_letters(letter);
});



/******************/

/** multi-search **/

/******************/



$(document).on('click','.checkbox', function() {

	var checkbox = $(this);

	var input_checkbox = $(checkbox).find('input');

	var checkbox_state = $(input_checkbox).prop('checked');

	var label = $(checkbox).find('label');

	

	if( $(checkbox).hasClass('select-all') ){

		$(checkbox).parent().find('.checkbox').each(function() {

			if(!checkbox_state){

				$(this).find('input').prop('checked', true);

				$(this).find('label').addClass('checked');

			} else {

				$(this).find('input').prop('checked', false);

				$(this).find('label').removeClass('checked');

			}

		});

	} else {

		if(!checkbox_state){

			$(input_checkbox).prop('checked', true);

			$(label).addClass('checked');

		} else {

			$(input_checkbox).prop('checked', false);

			$(label).removeClass('checked');

		}

	}

});



$(document).on('submit','form.multi-search', function(e) {

	

	ajax_loader('on');

	var data = $( this ).serialize();

	$('.posts').html('');

	

	if( $(this).find('input.dvash').val() != '' ){

		e.preventDefault();

		return false;

	}

	

	jQuery.post(

		'/wp-admin/admin-ajax.php', 

		{

			'action': 'dm_multi_search',

			'data': data

		}, 

		function(response){

			if( response.indexOf('errors') >= 0 ){

				dm_alert(response);

			} else {

				$('.posts').html(response);

				scroll_to_element($('.ajax-results'));

			}

			ajax_loader('off');

		}

	)	

	

	e.preventDefault();



});





$(document).on('click','.ajax-results a.page-numbers', function(e) {

	

	ajax_loader('on');

	

	var page = $(this);

	var page_url = $(page).attr('href');

	var wrapper = $(page).closest('div[data-page]');

	var site = $(wrapper).attr('data-site');

	var data = $( 'form.multi-search' ).serialize();

	

	jQuery.post(

		'/wp-admin/admin-ajax.php', 

		{

			'action': 'refresh_paging',

			'site': site,

			'data': data,

			'page_url': page_url,

		}, 

		function(response){

			$(wrapper).parent().html(response);

			ajax_loader('off');

		}

	)

	

	e.preventDefault();



});



/*****************/

/** video votes **/

/*****************/

$(document).on('click','a[data-rating]', function(e) {

	

	//ajax_loader('on');

	

	var site_id = $(this).parent().attr('data-site');

	var video_id = $(this).parent().attr('data-id');

	var rating = $(this).attr('data-rating');

	

	$is_voted = checkCookie( 'site_'+ site_id +'_video_id_' + video_id);

	

	if($is_voted){

		//dm_alert(video_id + ' You alredy voted for '+ rating );

		//ajax_loader('off');

		

		//alert(video_id + ' You alredy voted for '+ rating );

	} else {

		//alert(video_id + ' Your vote is '+ rating );

		video_vote(video_id,rating);

	}

	

});



/*

$(document).on('hover focus','a[data-rating]', function(e) {

	

	var stars = $(this).parent();

	var original_stars = $(stars).html();

	var site_id = $(stars).attr('data-site');

	var video_id = $(stars).attr('data-id');

	var rating = $(this).attr('data-rating');

	

	var voted = getCookie( 'site_'+ site_id +'_video_id_' + video_id);

	

	if(voted){

		//alert('1');

	} else {

		$(stars).addClass('pointer-on');

		var stars_html = '';

		var star = '';

		for (i = 1; i < 6; i++) {

			if(rating <= i){

				star = '-o';

			} else {

				star = '';

			}

			stars_html += '<a data-rating="1"><i class="fa fa-star'+star+'" aria-hidden="true"></i></a>';

		}

		$(stars).html(stars_html);

	}



});

*/

function video_vote(video_id,rating,site_id) {

    jQuery.post(

		'/wp-admin/admin-ajax.php', 

		{

			'action': 'video_vote',

			'video_id': video_id,

			'site_id': site_id,

			'rating': rating

		}, 

		function(response){

			ajax_loader('off');

			//alert('you voted!');

		}

	)

}



/* ect. */

function scroll_to_element(elem){

	

	var mobile_header = is_mobile ? 30 + $('.wrap').height() : 0;

	//mobile_header = mobile_header && $('body').hasClass('sticky') ? 76 : 0;

	

	$('html, body').animate({

		scrollTop: elem.offset().top - mobile_header

	}, 500);

}



/**/

function set_position_click_to_call(){

	var last_link_position = $('.header-menu').offset().left;

	var tel_btn = $('a.tel-btn');
	
	if (tel_btn.length < 1) return;

	var tel_btn_left = tel_btn.offset().left + tel_btn.width();

	

	if(tel_btn_left >= last_link_position){

		tel_btn.css({top:'150px'});

	}

}



$(document).on('ready',set_position_click_to_call());

$(window).on('resize',function(){

	console.log(1);

	set_position_click_to_call();

});



$(document).ready( function(){

	if( $('body').hasClass('explorer') ){

		var the_img = $('img.ajax-loader');

		var old_src = the_img.attr('src');

		var new_src = old_src.replace("svg", "gif");

		the_img.attr('src',new_src);

	}

});



/* end jQuery */

})(jQuery);


// responsive table

(function($){
	
	const tableChild = $('.tablepress thead tr').children();
	const childArray = []
	$.each(tableChild, function(index, child) {
		
		childArray.push(child.innerText);
		
	  });


	var tbodyChild = $('tbody.row-hover').children(); 

	tbodyChild.each(function(i,child){
		$(this).children().each(function(i,child){
			$(this).attr('data-title', childArray[i]);
			$(this).wrapInner('<div class="inner-content"></div>')
		})
	})
	
	
	var parts = window.location.href.split('/');
	var lastSegment = parts.pop() || parts.pop();  // handle potential trailing slash

	// console.log(lastSegment);


})(jQuery)